function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .clsx-1{fill:#fff;stroke:#1b1464;stroke-width:4px}.clsx-2{fill:#1b1464}.clsx-3{fill:#d53d53}.clsx-6{fill:#31adff}.clsx-7{stroke:none}.clsx-8{fill:none}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_15496",
  transform: "translate(-1057.689 -3604.127)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1990",
  className: "clsx-1",
  transform: "translate(1057.689 3604.127)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 58,
  height: 42.829,
  className: "clsx-7",
  rx: 8
}), /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 38.829,
  x: 2,
  y: 2,
  className: "clsx-8",
  rx: 6
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_9052",
  d: "M0 0h56.022v6.282H0z",
  className: "clsx-2",
  transform: "translate(1057.734 3615.548)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1992",
  width: 17.4,
  height: 5.711,
  className: "clsx-3",
  rx: 2.855,
  transform: "translate(1066.389 3630.396)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1990-2",
  width: 65.18,
  height: 48.54,
  fill: "#fff",
  rx: 4,
  transform: "translate(1089.589 3621.858)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1991",
  fill: "#324577",
  d: "M0 0H52.347V9.178H0z",
  transform: "translate(1099.941 3639.042)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1992-2",
  width: 9.518,
  height: 4.589,
  className: "clsx-6",
  rx: 0.8,
  transform: "translate(1104.541 3657.049)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1993",
  width: 12.69,
  height: 4.589,
  className: "clsx-6",
  rx: 0.8,
  transform: "translate(1117.231 3657.049)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1990-3",
  className: "clsx-1",
  transform: "translate(1096.769 3627.569)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.106,
  height: 42.829,
  className: "clsx-7",
  rx: 8
}), /*#__PURE__*/React.createElement("rect", {
  width: 53.106,
  height: 38.829,
  x: 2,
  y: 2,
  className: "clsx-8",
  rx: 6
})), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1991-2",
  d: "M0 0H55.202V6.282H0z",
  className: "clsx-2",
  transform: "translate(1096.769 3638.334)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1992-3",
  width: 17.132,
  height: 5.711,
  className: "clsx-3",
  rx: 2.855,
  transform: "translate(1105.335 3653.752)"
}));

var SvgMoneyTransfer = function SvgMoneyTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97.08,
    height: 66.271,
    viewBox: "0 0 97.08 66.271",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoneyTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moneyTransfer.003054c8.svg";
export { ForwardRef as ReactComponent };